import pluralize from 'pluralize';

import { TextBadge } from '../shared/component-parts';
import { ViewProps } from './guided-research.constants';
import { getRegionalisedQrCodeLink } from 'approot/shared/logic/get-regionalised-qr-code-link';
import {
  PrintStimulusLink,
  PrintStimulusLinkNarrow,
} from '../print/print-stimulus';
import { COMPONENT_LAYOUT_LIST } from 'global/constants';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';

const GuidedResearchPrint = (
  props: ViewProps &
    CommonPrintProps & { contentVersion: string | null | undefined }
) => {
  if (!props.stimulusResourceProperties) return null;

  const printStimulusLinkProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    link: getRegionalisedQrCodeLink(
      props.stimulusResourceProperties.slug || '',
      props.contentVersion
    ),
    details: (
      <TextBadge
        text={`${props.stimulusResourceProperties.links.length} ${pluralize(
          'link',
          props.stimulusResourceProperties.links.length
        )}`}
      />
    ),
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <PrintStimulusLinkNarrow
          {...printStimulusLinkProps}
          isPrintPreview={props.isPrintPreview}
        />
      ) : (
        <PrintStimulusLink
          {...printStimulusLinkProps}
          isPrintPreview={props.isPrintPreview}
        />
      )}
    </>
  );
};

export default GuidedResearchPrint;
